import React, { useState, useEffect } from 'react'
import { useHistory } from "react-router-dom";
import i18n from '@dhis2/d2-i18n'
import classes from '../../App.module.css'
import { makeStyles } from '@material-ui/core/styles';
import { apiServices } from '../../services/apiServices'

import { db, auth } from '../../firebaseConfig';

//import SearchBar from '../../component/searchbar/SearchBar';
//import CaseList from './NewThemeCaseList'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import DataTable from 'react-data-table-component';
import Pagination from "@material-ui/lab/Pagination";
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import SyncIcon from '@material-ui/icons/Sync';
//import PersonOffIcon from '@material-ui/icons/PersonOff';
import PersonIcon from '@material-ui/icons/Person';
import BlockIcon from '@material-ui/icons/Block';
import _ from "lodash";
import SearchBar from 'material-ui-search-bar';
import {
    Button,
    ButtonStrip,
    Divider,
    InputFieldFF,
    SingleSelectFieldFF,
    ReactFinalForm,
    hasValue,
    InputField,
    CircularLoader,
    CenteredContent
} from '@dhis2/ui';
import { withTranslation, Trans, useTranslation } from 'react-i18next';
import swal from 'sweetalert'
import OfflineDb from '../../db'
import { useGlobalSpinnerActionsContext } from '../../context/GlobalSpinnerContext'
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import IconButton from "@material-ui/core/IconButton";
import CardHeader from "@material-ui/core/CardHeader";
import CloseIcon from "@material-ui/icons/Close";

import Box from "@material-ui/core/Box"
//import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import FilledInput from '@material-ui/core/FilledInput';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import '../../assets/css/customstyles.css'
import '../../assets/css/theme_blue.css'

import FooterMenu from '../../component/layout/FooterMenu'
import imgUrl from '../../assets/images/imageUrl'
import moment from 'moment';
import Autocomplete from "@material-ui/lab/Autocomplete"

const { Form, Field } = ReactFinalForm

function MobileSearch() {
    const history = useHistory();
    const [value, setValue] = useState([])
    const [programData, setProgramData] = useState(null)
    const [sessionUserBoValue, setSessionUserBoValue] = React.useState(null)
    const [UIC, setUIC] = React.useState(null)
    // const [loading,setGlobalSpinner] = useState(false)
    const { t } = useTranslation()
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [usersData, setUsersData] = useState(null)
    const [usersAllData, setAllUsersData] = useState(null)
    const [ConfigurationFromServer, setConfigurationFromServer] = useState(null);
    const [activeCaseDetails, setActiveCaseDetails] = useState(null);
    const [activeCaseFormData, setActiveCaseFormData] = useState(null)
    const [organisationDetails, setorgDetails] = useState(null)
    const [geolocation, setGeoLocation] = useState(null)
    const [currentGeolocation, setCurrentGeoLocation] = useState(null)
    const [searchInputValue, setSearchInputValue] = useState('')

    //pagination code
    const [page, setPage] = useState(1);
    const [noOfPages, setNoOfPages] = useState(0)
    const [OUJSON, setOUJSON] = useState(null)

    async function getMetaData() {
        let metadata = await OfflineDb.getDataFromPouchDB('metaData')
        setProgramData(metadata.data)

        let loginDetails = await OfflineDb.getDataFromPouchDB('loginDetails')
        setSessionUserBoValue(loginDetails.data)

        let configurations = await OfflineDb.getDataFromPouchDB('configurations')
        setConfigurationFromServer(configurations.data.configuration)

        let CaseDetails = await OfflineDb.getDataFromPouchDB('activeCaseDetails')
        setActiveCaseDetails(CaseDetails)
        let orgDetails = await OfflineDb.getDataFromPouchDB('orgDetails')
        // console.log("orgDetails", orgDetails)
        setorgDetails(orgDetails.data)
    }

    const getUserList = async (userId) => {
        try {
            const snapshot = await db.collection('users')
                .where('isSynced', '!=', true)
                .get();

            const users = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            setUsersData(users)
            setAllUsersData(users)
            users.map((obj, i) => {
                users[i]["edit"] = <div className="table-action" onClick={() => newCaseClick(obj)}><Button>Complete</Button></div>
            })
            // console.log("userDoc", users);
            return users;
        } catch (error) {
            console.error("Error fetching users:", error);
            return null;
        }
    };

    useEffect(() => {
        setGlobalSpinner(true)
        getMetaData()
    }, [])

    useEffect(() => {
        if (programData != null && sessionUserBoValue != null && ConfigurationFromServer != null && currentGeolocation != null && organisationDetails != null) {
            setGlobalSpinner(false)
        }
    }, [programData, sessionUserBoValue, ConfigurationFromServer, currentGeolocation, organisationDetails])

    useEffect(() => {
        if (organisationDetails != null)
            getUserList()
    }, [programData, organisationDetails])

    useEffect(() => {
        if (navigator.geolocation && geolocation != null) {
            navigator.geolocation.getCurrentPosition((position) => {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                setCurrentGeoLocation({ "lat": latitude, "lng": longitude })
            }, (error) => {
                setCurrentGeoLocation({ "lat": geolocation.lat, "lng": geolocation.lng })
            }, { timeout: 10000 });
        } else if (geolocation != null) {
            setCurrentGeoLocation({ "lat": geolocation.lat, "lng": geolocation.lng })
        } else {
            setCurrentGeoLocation({ "lat": -74.013382, "lng": 40.712742 })
            setGeoLocation({ "lat": -74.013382, "lng": 40.712742 })
        }
    }, [geolocation])

    const editCase = (row) => {
        // console.log("userdata", row)
    }

    const columns = [
        {
            name: t('Ocuupation'),
            selector: row => row["occupation"]
        },
        {
            name: t('Name'),
            selector: row => row["name"]
        },
        {
            name: t('Age'),
            selector: row => row["age"]
        },
        {
            name: t('Gender'),
            selector: row => row["gender"]
        },
        {
            name: t('Mobile number'),
            selector: row => row["phoneNumber"]
        },
        {
            name: t('State'),
            selector: row => row["state"]
        },
        {
            name: t('Complete Registration'),
            selector: row => row.edit
        }
    ]

    function resetSearch(){
        setSearchInputValue('');
        setUsersData(usersAllData)
    }

    async function generateUIC() {
        try {
            const response = await apiServices.generateUIC("OFWQ7SGDoGc");

            let orgdata = organisationDetails?.ancestors;
            const level3Item = orgdata.find(item => item.level === 3);
            const level4Item = orgdata.find(item => item.level === 4);

            const uic = `${level3Item.code}-${level4Item.name.slice(0, 2).toUpperCase()}-${organisationDetails?.code}-${response.value}`;
            setUIC(uic);
            return uic;
        } catch (err) {
            setGlobalSpinner(false);
            throw err; // Optional: rethrow if you want to handle errors outside
        } finally {
            setGlobalSpinner(false);
        }
    }

    function newCaseClick(obj) {
        localStorage.setItem('fbuserid', obj.id)
        OfflineDb.removeDataFromPouchDB("activeCaseDetails");
        //OfflineDb.removeDataFromPouchDB("activeCaseFormData");
        OfflineDb.removeDataFromPouchDB("linkContactFlag");
        OfflineDb.setDataIntoPouchDB("transferFlag", { type: null });

        const activeCaseFormData = {
            "data": {
                'formFormat': { 
                    "qrMegjSEytt": obj.name, 
                    "tUUPZDHE5vq": obj.phoneNumber.replace(/^(\+91[\s-]?)/, ''), 
                    "MYu4DOMbDjq": obj.age,
                    "iIqdsh2TJG8": obj.gender,
                    "KGXkjC1tv3c": obj.occupation,
                    "H8Y5QHSiE7a": obj.state
                },
                'redirectFromReg':true,
                'dhisFormat': null //
            }
        }

        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData.data)
        setActiveCaseFormData(activeCaseFormData)
        history.push("/layout/registration");
    }

    async function saveRegData(uservalues) {
        try {
            const offlineUIC = (len, chars = 'A0B1C2D3E4F5G6H7I8J9K0L1M2N3O4P5Q6R7S8T9U0V1W2X3Y4Z5') => [...Array(len)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('')
            // valueForFormInput[customfieldobj.uicId] = "OFF" + offlineUIC(12)

        } catch (e) { }

        const UIC = await generateUIC();

        let valuesToSave = [
            { "attribute": "qrMegjSEytt", value: uservalues.name },
            { "attribute": "tUUPZDHE5vq", value: uservalues.phoneNumber },
            { "attribute": "OFWQ7SGDoGc", value: UIC }]

        checkDuplicateId(uservalues.phoneNumber, "tUUPZDHE5vq", function (callbackResponse) {
            if (callbackResponse) {
                const orgUnit = sessionUserBoValue.organisationUnits[0].id
                const trackedEntityType = programData.programs[0].trackedEntityType.id
                let registrationFields = programData.programs[0].programTrackedEntityAttributes

                let saveCaseInput = {
                    "trackedEntityType": trackedEntityType,
                    "orgUnit": orgUnit,
                    "attributes": valuesToSave,
                    "enrollments": [
                        {
                            "program": programData.programs[0].id,
                            "orgUnit": orgUnit,
                            "enrollmentDate": moment().format("YYYY-MM-DD"),
                            "incidentDate": moment().format("YYYY-MM-DD")
                        }
                    ],
                    "geometry": { "type": "Point", "coordinates": [currentGeolocation.lng, currentGeolocation.lat] }
                }

                var code = generateQRCode(8)
                let qrcode = { "attribute": "AKOOhFRVRlO", "value": code }
                valuesToSave.push(qrcode);
                //valueForFormInput[qrCodeId] = code

                if (navigator.onLine) {
                    setGlobalSpinner(true)
                    registerNewUSer(saveCaseInput);
                }
            }
        })
    }

    function checkDuplicateId(phonenumber, Idtobechecked, callback) {
        if (navigator.onLine) {
            setGlobalSpinner(true)
            let fieldname = "Phone number";
            let orgID = sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
                programID = programData.programs[0].id, //`nSy7PFqQykt`,
                searchQuery = ``;

            searchQuery += `&attribute=${Idtobechecked}:LIKE:${phonenumber}`;

            let subURL =
                "trackedEntityInstances/query.json?ou=" +
                orgID +
                "&ouMode=ACCESSIBLE&&order=created:desc&program=" +
                programID +
                searchQuery +
                "&pageSize=50&page=1&totalPages=false&skipPaging=true";

            apiServices
                .getAPI(subURL)
                .then((res) => {
                    setGlobalSpinner(false)
                    // console.log("response ", res.data.rows)
                    if (res && res.data) {
                        if (res.data.rows && res.data.rows.length > 0) {
                            swal({
                                title: t(`The entered ${fieldname} is already registered on the system.`),
                                text: '',
                                icon: "warning",
                            }).then((AlertRes) => {
                                callback(false)
                            })
                        } else {
                            callback(true)
                        }
                    } else {
                        callback(true)
                    }
                }).catch(err => {
                    setGlobalSpinner(false)
                    callback(true)
                })
        } else {
            setGlobalSpinner(false)
            callback(true)
        }
    }

    function generateQRCode(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return "dureProg_" + result;
    }

    function registerNewUSer(saveCaseInput) {
        apiServices.postAPI('trackedEntityInstances', saveCaseInput)
            .then(response => {

                const trackedEntityInstance = response.data.response.importSummaries[0].reference

                swal({
                    title: t("Success"),
                    text: t("Individual Registered"),
                    icon: "success",
                    button: t("Close"),
                });
                setGlobalSpinner(false)
            }).catch(err => {

                swal({
                    title: t("Error"),
                    text: "",
                    icon: "error",
                    button: t("Close"),
                });
                setGlobalSpinner(false)
            })
    }

    return (
        <section
            className="searchcustombg searchtabmaindiv"
            style={{
                flexGrow: 1,
                padding: "0px !important",
            }}>
            <FooterMenu></FooterMenu>
            <Grid container>
                <Grid item xs={4} sm={4} md={4}>
                    <div className="table-header">
                        <h3 className="text-uppercase zero">
                            <Trans>Mobile Registration</Trans>
                        </h3>
                    </div>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                        <SearchBar
                        value={searchInputValue}
                        onChange={(newValue) =>setSearchInputValue(newValue)}
                        className="searchbar-block"
                        onCancelSearch={() => resetSearch()}
                        />
                    </Grid>
                    {/* <Grid item xs={1} sm={1} md={1}>
                        <div onClick={()=>loadFilter()}><img src={imgUrl.filter} width="30"/></div>
                    </Grid> */}
                </Grid>
                </Grid>
            </Grid>
            <Grid container>
                <Grid xs={12} sm={12} md={12} className={"datatable-block"} spacing={3}>
                    <DataTable
                        //title="Line List"
                        striped="true"
                        responsive="true"
                        pagination
                        fixedHeader="true"
                        columns={columns}
                        // data={usersData?.filter((item) => {
                        //     return item;
                        // })}



                         data={usersData?.filter((item) => {
                                        if (searchInputValue === "") {
                                          return item;
                                        } else if (
                                            (item["name"] && item["name"].toLowerCase().includes(searchInputValue.toLowerCase())) ||
                                            (item["Age"] && item["Age"].toLowerCase().includes(searchInputValue.toLowerCase())) ||
                                            (item["Gender"] && item["gender"].toLowerCase().includes(searchInputValue.toLowerCase())) ||
                                            (item["phoneNumber"] && item["phoneNumber"].toLowerCase().includes(searchInputValue.toLowerCase()))
                                            
                                        ) {
                                          return item;
                                        }
                                      })}

                    />
                </Grid>
            </Grid>
        </section>
    )
}
export default MobileSearch;